<template>
    <WarehouseCard v-if="warehouse" :warehouse="warehouse"/>
    <AvailabilityCard v-if="warehouse?.uuid" :warehouse="warehouse"/>
    <FixedBottomNavbar>
        <ul class="navbar-nav ml-md-auto">
            <li class="nav-item py-1">
                <Button size="sm" color="danger" class="mr-2" @click="remove">
                    <i class="icon-trash mr-2"></i>
                    <span>{{ $t('buttons.delete') }}</span>
                </Button>
            </li>
            <li class="nav-item py-1">
                <Button size="sm" color="indigo" @click="edit">
                    <i class="icon-floppy-disk mr-2"></i>
                    <span>{{ $t('buttons.save') }}</span>
                </Button>
            </li>
        </ul>
    </FixedBottomNavbar>
</template>
<script>
import WarehouseCard from './cards/WarehouseCard.vue';
import AvailabilityCard from './cards/AvailableCard.vue';
import FixedBottomNavbar from '../../../../components/new/navbars/FixedBottomNavbar.vue';
import Button from '../../../../components/new/button/AppButton.vue';
import { httpClient } from '../../../../services/HttpClient';
import MessageNotificator from '../../../../services/MessageNotificator.js';
export default {
    name: 'EditWarehousePage',
    components: {
        WarehouseCard, AvailabilityCard, FixedBottomNavbar, Button
    },
    data() {
        return {
            warehouse: null
        }
    },
    methods: {
        async fetchWarehouse() {
            await httpClient.get(`/management/warehouses/${this.$route.params.warehouseUuid}`).then(response => {
                this.warehouse = response.data.data
            })
        },
        async edit() {
            await httpClient.patch(`/management/warehouses/${this.warehouse.uuid}`, {
                name: this.warehouse.name
            }).then(response => {
                this.warehouse = response.data.data
                new MessageNotificator().success(this.$t('alerts.success'))
            })
        },
        remove() {
            new MessageNotificator().confirm(this.$t('alerts.delete_warehouse'), async () => {
                await httpClient.delete(`/management/warehouses/${this.warehouse.uuid}`).then(() => {
                    this.$router.push({ name: 'IndexWarehousePage' })
                })
            })
        }
    },
    mounted() {
        this.fetchWarehouse()
    }
}
</script>
